
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4dpqU", function(module, exports) {
$parcel$export(module.exports, "buildManifest", () => (parcelRequire("gEHBP")).buildManifest);

var $gEHBP = parcelRequire("gEHBP");



var $9LoQD = parcelRequire("9LoQD");


var $b3cafeee441efa6f$export$2e2bcd8739ae039 = (0, $gEHBP.buildManifest);

});

parcelRegister("9P5aG", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $98ee67ed40b4824b$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    styleExpand: {
        id: "extension.charts.style",
        defaultMessage: "Style"
    },
    titleExpand: {
        id: "extension.charts.title",
        defaultMessage: "Title"
    },
    legendExpand: {
        id: "extension.charts.legend",
        defaultMessage: "Legend"
    },
    dataTabTitle: {
        id: "extension.charts.dataTab",
        defaultMessage: "Data"
    },
    customizeTabTitle: {
        id: "extension.charts.customizeTab",
        defaultMessage: "Customize"
    },
    aggregateData: {
        id: "extension.charts.aggregateData",
        defaultMessage: "Aggregate data"
    },
    aggregateDataDescription: {
        id: "extension.charts.aggregateDataDescription",
        defaultMessage: "Combine values into a single data point when multiple rows have the same value."
    },
    orientationLabel: {
        id: "extension.charts.orientation.label",
        defaultMessage: "Orientation"
    },
    verticalOrientation: {
        id: "extension.charts.vertical.orientation.label",
        defaultMessage: "Vertical"
    },
    horizontalOrientation: {
        id: "extension.charts.horizontal.orientation.label",
        defaultMessage: "Horizontal"
    },
    extensionTitle: {
        id: "extension.charts.extensionTitle",
        defaultMessage: "Chart"
    },
    insertChartTooltip: {
        id: "extension.charts.insert.tooltip",
        defaultMessage: "Insert chart"
    },
    chartOptionsLabel: {
        id: "extension.charts.options.label",
        defaultMessage: "Chart options"
    },
    chartOptionsTooltip: {
        id: "extension.charts.options.tooltip",
        defaultMessage: "Change chart options"
    },
    chartTypeBar: {
        id: "extension.charts.type.bar",
        defaultMessage: "Bar"
    },
    chartTypeLine: {
        id: "extension.charts.type.line",
        defaultMessage: "Line"
    },
    chartTypePie: {
        id: "extension.charts.type.pie",
        defaultMessage: "Pie"
    },
    chartTypeField: {
        id: "extension.charts.type.fieldDescription",
        defaultMessage: "Chart type"
    },
    heightField: {
        id: "extension.charts.height",
        defaultMessage: "Plot area height"
    },
    showLegend: {
        id: "extension.charts.legend.show",
        defaultMessage: "Show legend"
    },
    legendPosition: {
        id: "extension.charts.legend.position",
        defaultMessage: "Legend Position"
    },
    legendAuto: {
        id: "extension.charts.legend.auto",
        defaultMessage: "Auto"
    },
    legendTop: {
        id: "extension.charts.legend.top",
        defaultMessage: "Top"
    },
    legendLeft: {
        id: "extension.charts.legend.left",
        defaultMessage: "Left"
    },
    legendRight: {
        id: "extension.charts.legend.right",
        defaultMessage: "Right"
    },
    legendBottom: {
        id: "extension.charts.legend.bottom",
        defaultMessage: "Bottom"
    },
    showPoints: {
        id: "extension.charts.showPoints",
        defaultMessage: "Show data points"
    },
    smoothLines: {
        id: "extension.charts.smoothLines",
        defaultMessage: "Smooth lines"
    },
    chartTitle: {
        id: "extension.charts.userTitle",
        defaultMessage: "Title"
    },
    yLabel: {
        id: "extension.charts.yLabel",
        defaultMessage: "Y-axis label"
    },
    xLabel: {
        id: "extension.charts.xLabel",
        defaultMessage: "X-axis label"
    },
    xAxisSeriesName: {
        id: "extension.charts.xAxis",
        defaultMessage: "X-axis"
    },
    categoryName: {
        id: "extension.charts.category",
        defaultMessage: "Category"
    },
    seriesNames: {
        id: "extension.charts.seriesNames",
        defaultMessage: "Data series"
    },
    defaultTitle: {
        id: "extension.charts.defaultTitle",
        defaultMessage: "Untitled chart"
    },
    defaultYLabel: {
        id: "extension.charts.defaultYLabel",
        defaultMessage: "Untitled axis"
    },
    defaultColumnName: {
        id: "extension.charts.defaultColumnName",
        defaultMessage: "Column {0}"
    },
    dataMissingTitle: {
        id: "extension.charts.dataMissing.title",
        defaultMessage: "No data to display"
    },
    dataMissingDetails: {
        id: "extension.charts.dataMissing.details",
        defaultMessage: "We can\u2019t find this chart\u2019s source table on the page."
    },
    small: {
        id: "extension.charts.height.small",
        defaultMessage: "Shorter"
    },
    medium: {
        id: "extension.charts.height.medium",
        defaultMessage: "Default"
    },
    large: {
        id: "extension.charts.height.large",
        defaultMessage: "Taller"
    },
    editSourceLabel: {
        id: "extension.charts.editSource.label",
        defaultMessage: "Edit source"
    },
    editSourceTooltip: {
        id: "extension.charts.editSource.tooltip",
        defaultMessage: "Jump to the source table to edit values"
    }
});
module.exports["i18n"] = $98ee67ed40b4824b$export$a7357cdd1f0b0168;

});

parcelRegister("9Lqvw", function(module, exports) {
const $0c64e63f44b0156a$export$84db5f322b6bede2 = (num)=>{
    const n = Number(num);
    if (Number.isNaN(n)) return null;
    return n;
};
const $0c64e63f44b0156a$var$rowHasNumber = (parseNumber)=>(entity)=>{
        if (entity === undefined) return false;
        const cols = entity.content;
        if (!cols) return false;
        return cols.some((col)=>{
            const colText = $0c64e63f44b0156a$export$c72d34660a162238(col).trim();
            if (!colText.length) return false;
            const colNumber = parseNumber(colText);
            // console.log('col', colText, colNumber);
            return colNumber !== null;
        });
    };
const $0c64e63f44b0156a$export$5f9db210835129c = (table, copyMerged = false)=>{
    const parsedRows = [];
    if (table.content) {
        const rows = table.content;
        if (!rows[0].content) return parsedRows;
        /* get n dimension by following first row */ let dim = 0;
        rows[0].content.forEach((col)=>{
            dim += col.attrs?.colspan || 1;
        });
        /* construct our mxn array */ for(let i = 0; i < rows.length; i++)parsedRows.push(new Array(dim));
        /* copy the values from the table into the array
		 * keeping in mind spans */ rows.forEach((row, i)=>{
            const cols = row.content;
            if (!cols) return;
            cols.forEach((col, j)=>{
                const text = $0c64e63f44b0156a$export$c72d34660a162238(col).trim();
                const colspan = col.attrs?.colspan || 1;
                const rowspan = col.attrs?.rowspan || 1;
                let isSpan = false;
                for(let ii = 0; ii < rowspan; ii++)for(let jj = 0; jj < colspan; jj++){
                    /* this block might've been allocated from a previous
						 * rowspan */ let next = 0;
                    while(parsedRows[i + ii][j + jj + next] !== undefined)next++;
                    /* only place the text in the first cell, and treat
						 * other cells as split (unless copy is true) */ if (!isSpan || copyMerged) {
                        parsedRows[i + ii][j + jj + next] = text;
                        isSpan = true;
                    } else parsedRows[i + ii][j + jj + next] = '';
                }
            });
        });
    }
    return parsedRows;
};
const $0c64e63f44b0156a$var$rowHasNumberAtCol = (parseNumber, colIdx)=>(row)=>{
        const col = row[colIdx];
        if (col === undefined) return false;
        const colNumber = parseNumber(col);
        return colNumber !== null;
    };
const $0c64e63f44b0156a$export$b311734df06d7f96 = (table, parseNumber, colIdx)=>{
    /* slice out the table heading row */ return table.slice(1).every($0c64e63f44b0156a$var$rowHasNumberAtCol(parseNumber, colIdx));
};
const $0c64e63f44b0156a$export$508ece546386d675 = (table, parseNumber)=>{
    if (table.content) {
        const rows = table.content;
        return rows.some($0c64e63f44b0156a$var$rowHasNumber(parseNumber));
    }
    return false;
};
const $0c64e63f44b0156a$export$c72d34660a162238 = (child)=>{
    if (!child) return '';
    // When paragraph text is broken up by a mark such as annotations, bold, italic etc.
    if (child.type === 'paragraph' && child.content) return child.content.map($0c64e63f44b0156a$export$c72d34660a162238).join('');
    if (child.content) return child.content.map($0c64e63f44b0156a$export$c72d34660a162238).join('\n');
    return child.text || '';
};
module.exports["defaultParseNumber"] = $0c64e63f44b0156a$export$84db5f322b6bede2;
module.exports["parseTable"] = $0c64e63f44b0156a$export$5f9db210835129c;

});

parcelRegister("8PJdr", function(module, exports) {

var $1To4a = parcelRequire("1To4a");

const $42c4976553b640dc$export$c07180e0eb2fbe84 = [
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.blue.bolder', '#0055CC')
    },
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.green.bold', '#23A971')
    },
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.yellow.bolder', '#FF9D00')
    },
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.red.bold', '#FC552C')
    },
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.purple.bolder', '#5A43D0')
    },
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.blue.bold', '#247FFF')
    },
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.green.boldest', '#055C3F')
    },
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.yellow.bold', '#FFBE33')
    },
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.red.boldest', '#A32000')
    },
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.purple.bold', '#8B77EE')
    },
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.blue.boldest', '#003884')
    },
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.green.bolder', '#177D52')
    },
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.yellow.boldest', '#9A6104')
    },
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.red.bolder', '#D32D03')
    },
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.purple.boldest', '#44368B')
    },
    // These colors don't have chart tokens since they're subtle colors - using 'color.background'
    {
        getValue: ()=>(0, $1To4a.default)('color.background.accent.blue.subtle', '#7AB2FF')
    },
    {
        getValue: ()=>(0, $1To4a.default)('color.background.accent.green.subtle', '#6BE1B0')
    },
    {
        getValue: ()=>(0, $1To4a.default)('color.background.accent.yellow.subtle', '#FFDB57')
    },
    {
        getValue: ()=>(0, $1To4a.default)('color.background.accent.red.subtle', '#FF8F73')
    },
    {
        getValue: ()=>(0, $1To4a.default)('color.background.accent.purple.subtle', '#B5A7FB')
    }
];
const $42c4976553b640dc$export$456f919fad9ce4eb = [
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.blue.bolder', '#0055CC')
    },
    // Dark blue
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.green.bold', '#23A971')
    },
    // Green
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.yellow.bolder', '#FF9D00')
    },
    // Dark yellow
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.red.bold', '#FC552C')
    },
    // Red
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.purple.bolder', '#5A43D0')
    },
    // Dark purple
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.blue.bold', '#247FFF')
    },
    // Blue
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.green.boldest', '#055C3F')
    },
    // Darker green
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.yellow.bold', '#FFBE33')
    },
    // Yellow
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.red.boldest', '#A32000')
    },
    // Darker red
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.purple.bold', '#8B77EE')
    },
    // Purple
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.blue.boldest', '#003884')
    },
    // Darker blue
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.green.bolder', '#177D52')
    },
    // Dark green
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.red.bolder', '#D32D03')
    },
    // Dark red
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.purple.boldest', '#44368B')
    },
    // Darker purple
    // These colors don't have chart tokens that are even close - using color.background
    {
        getValue: ()=>(0, $1To4a.default)('color.background.accent.blue.subtle', '#7AB2FF')
    },
    // Light blue
    {
        getValue: ()=>(0, $1To4a.default)('color.background.accent.green.subtle', '#6BE1B0')
    },
    // Light green
    {
        getValue: ()=>(0, $1To4a.default)('color.background.accent.yellow.subtle', '#FFDB57')
    },
    // Light yellow
    {
        getValue: ()=>(0, $1To4a.default)('color.background.accent.red.subtle', '#FF8F73')
    },
    // Light red
    {
        getValue: ()=>(0, $1To4a.default)('color.background.accent.purple.subtle', '#B5A7FB')
    },
    // Light purple
    // new colors added
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.teal.boldest', '#206B74')
    },
    // Darker Teal
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.orange.bold', '#D97008')
    },
    // Orange
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.yellow.boldest', '#9A6104')
    },
    // Darker yellow
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.magenta.bold', '#DA62AC')
    },
    // Magenta
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.orange.boldest', '#974F0C')
    },
    // Darker orange
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.gray.bold', '#8590A2')
    },
    // Gray
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.magenta.boldest', '#943D73')
    },
    // Darker magenta
    {
        getValue: ()=>(0, $1To4a.default)('color.background.accent.teal.subtle', '#60C6D2')
    },
    // Light teal
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.gray.boldest', '#44546F')
    },
    // Darker gray
    {
        getValue: ()=>(0, $1To4a.default)('color.background.accent.orange.subtle', '#FAA53D')
    },
    // Light orange
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.teal.bolder', '#1D7F8C')
    },
    // Dark teal
    {
        getValue: ()=>(0, $1To4a.default)('color.background.accent.magenta.subtle', '#E774BB')
    },
    // Light magenta
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.orange.bolder', '#B65C02')
    },
    // Dark orange
    {
        getValue: ()=>(0, $1To4a.default)('color.background.accent.gray.subtler', '#8993A5')
    },
    // Light Gray
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.magenta.bolder', '#CD519D')
    },
    // Dark magenta
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.gray.bolder', '#758195')
    },
    // Dark gray
    {
        getValue: ()=>(0, $1To4a.default)('color.chart.teal.bold', '#1D9AAA')
    } // Teal
];
const $42c4976553b640dc$export$5b6e12a31da3a4e6 = [
    "var(--ds-chart-blue-bolder, #357DE8)",
    "var(--ds-chart-green-bold, #22A06B)",
    "var(--ds-chart-yellow-bolder, #946F00)",
    "var(--ds-chart-red-bold, #F15B50)",
    "var(--ds-chart-purple-bolder, #AF59E1)",
    "var(--ds-chart-blue-bold, #4688EC)",
    "var(--ds-chart-green-boldest, #216E4E)",
    "var(--ds-chart-yellow-bold, #B38600)",
    "var(--ds-chart-red-boldest, #AE2E24)",
    "var(--ds-chart-purple-bold, #BF63F3)",
    "var(--ds-chart-blue-boldest, #1558BC)",
    "var(--ds-chart-green-bolder, #1F845A)",
    "var(--ds-chart-yellow-boldest, #7F5F01)",
    "var(--ds-chart-red-bolder, #E2483D)",
    "var(--ds-chart-purple-boldest, #803FA5)",
    "var(--ds-background-accent-blue-subtle, #669DF1)",
    "var(--ds-background-accent-green-subtle, #4BCE97)",
    "var(--ds-background-accent-yellow-subtle, #EED12B)",
    "var(--ds-background-accent-red-subtle, #F87168)",
    "var(--ds-background-accent-purple-subtle, #C97CF4)"
];
const $42c4976553b640dc$export$92e2c95202cfd8c = [
    "var(--ds-chart-blue-bolder, #357DE8)",
    "var(--ds-chart-green-bold, #22A06B)",
    "var(--ds-chart-yellow-bolder, #946F00)",
    "var(--ds-chart-red-bold, #F15B50)",
    "var(--ds-chart-purple-bolder, #AF59E1)",
    "var(--ds-chart-blue-bold, #4688EC)",
    "var(--ds-chart-green-boldest, #216E4E)",
    "var(--ds-chart-yellow-bold, #B38600)",
    "var(--ds-chart-red-boldest, #AE2E24)",
    "var(--ds-chart-purple-bold, #BF63F3)",
    "var(--ds-chart-blue-boldest, #1558BC)",
    "var(--ds-chart-green-bolder, #1F845A)",
    "var(--ds-chart-red-bolder, #E2483D)",
    "var(--ds-chart-purple-boldest, #803FA5)",
    // These colors don't have chart tokens - using color.background
    "var(--ds-background-accent-blue-subtle, #669DF1)",
    "var(--ds-background-accent-green-subtle, #4BCE97)",
    "var(--ds-background-accent-yellow-subtle, #EED12B)",
    "var(--ds-background-accent-red-subtle, #F87168)",
    "var(--ds-background-accent-purple-subtle, #C97CF4)",
    // new colors added
    "var(--ds-chart-teal-boldest, #206A83)",
    "var(--ds-chart-orange-bold, #E06C00)",
    "var(--ds-chart-yellow-boldest, #7F5F01)",
    "var(--ds-chart-magenta-bold, #DA62AC)",
    "var(--ds-chart-orange-boldest, #7A3B00)",
    "var(--ds-chart-gray-bold, #8C8F97)",
    "var(--ds-chart-magenta-boldest, #943D73)",
    "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    "var(--ds-chart-gray-boldest, #505258)",
    "var(--ds-background-accent-orange-subtle, #FCA700)",
    "var(--ds-chart-teal-bolder, #227D9B)",
    "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "var(--ds-chart-orange-bolder, #BD5B00)",
    "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    "var(--ds-chart-magenta-bolder, #CD519D)",
    "var(--ds-chart-gray-bolder, #7D818A)",
    "var(--ds-chart-teal-bold, #2898BD)" // Teal
];
module.exports["colorSequence"] = $42c4976553b640dc$export$c07180e0eb2fbe84;
module.exports["colorSequenceForExtendedChartsColorPicker"] = $42c4976553b640dc$export$456f919fad9ce4eb;

});

parcelRegister("itfXp", function(module, exports) {

var $9P5aG = parcelRequire("9P5aG");


var $grNUj = parcelRequire("grNUj");


var $2NCZX = parcelRequire("2NCZX");


var $9Lqvw = parcelRequire("9Lqvw");

const $fa993e89223dfa5d$export$dd93950eefb60f52 = (0, $grNUj.ChartTypes).BAR;
const $fa993e89223dfa5d$export$4dfdff334e270aee = 350;
const $fa993e89223dfa5d$export$62c88ce5e28a89f7 = (0, $grNUj.Orientation).VERTICAL;
const $fa993e89223dfa5d$export$4865acd00276b97b = (0, $grNUj.UserLegendPosition).AUTO;
const $fa993e89223dfa5d$export$4f3e0c2bc77eca55 = (adf, intl, parseNumber)=>{
    const table = adf ? (0, $9Lqvw.parseTable)(adf) : [
        []
    ];
    const seriesOptions = (0, $2NCZX.createColumnNames)(table, intl);
    // CEMS-2210: blocked on CEMS-2227, use instead for yAxisIdxField's source
    // const validSeriesSelections = seriesOptions.filter((opt, idx) => {
    //   return columnHasNumbers(table, parseNumber, idx);
    // });
    const xAxisIdxField = (seriesOptions[0] || {
        value: undefined
    }).value;
    const yAxisIdxField = seriesOptions.filter((opt)=>opt.value !== '0').map((opt)=>opt.value);
    return {
        chartType: $fa993e89223dfa5d$export$dd93950eefb60f52,
        chartGroup: {
            dataTab: {
                aggregateData: false,
                xAxisIdxField: xAxisIdxField,
                yAxisIdxField: yAxisIdxField
            },
            customizeTab: {
                styleField: {
                    height: $fa993e89223dfa5d$export$4dfdff334e270aee,
                    showPoints: false,
                    smooth: false,
                    orientation: $fa993e89223dfa5d$export$62c88ce5e28a89f7
                },
                titlesField: {
                    chartTitle: intl.formatMessage((0, $9P5aG.i18n).defaultTitle),
                    yLabel: intl.formatMessage((0, $9P5aG.i18n).defaultYLabel),
                    xLabel: ''
                },
                legendField: {
                    legendPosition: (0, $grNUj.UserLegendPosition).AUTO,
                    showLegend: true
                }
            }
        },
        /* Lozenge.tsx in editor-core will end up capitalising the first letter */ extensionTitle: intl.formatMessage((0, $9P5aG.i18n).extensionTitle)
    };
};
module.exports["DEFAULT_CHART_TYPE"] = $fa993e89223dfa5d$export$dd93950eefb60f52;
module.exports["DEFAULT_CHART_HEIGHT"] = $fa993e89223dfa5d$export$4dfdff334e270aee;
module.exports["DEFAULT_LEGEND_POSITION"] = $fa993e89223dfa5d$export$4865acd00276b97b;
module.exports["defaultParameters"] = $fa993e89223dfa5d$export$4f3e0c2bc77eca55;

});

parcelRegister("grNUj", function(module, exports) {
var $3c0b938b12bd8171$export$cb0c28d82279ccf0 = /*#__PURE__*/ function(UserLegendPosition) {
    UserLegendPosition["AUTO"] = "auto";
    UserLegendPosition["TOP"] = "top";
    UserLegendPosition["LEFT"] = "left";
    UserLegendPosition["RIGHT"] = "right";
    UserLegendPosition["BOTTOM"] = "bottom";
    return UserLegendPosition;
}({});
var $3c0b938b12bd8171$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["VERTICAL"] = "vertical";
    Orientation["HORIZONTAL"] = "horizontal";
    return Orientation;
}({});
var $3c0b938b12bd8171$export$745b8a06b3d17988 = /*#__PURE__*/ function(ChartTypes) {
    ChartTypes["PIE"] = "PIE";
    ChartTypes["BAR"] = "BAR";
    ChartTypes["LINE"] = "LINE";
    return ChartTypes;
}({});
module.exports["UserLegendPosition"] = $3c0b938b12bd8171$export$cb0c28d82279ccf0;
module.exports["Orientation"] = $3c0b938b12bd8171$export$df54d73aa0ec5e82;
module.exports["ChartTypes"] = $3c0b938b12bd8171$export$745b8a06b3d17988;

});

parcelRegister("2NCZX", function(module, exports) {

var $9P5aG = parcelRequire("9P5aG");

function $0448137591457623$export$8bbd55d690f3e574(yAxisIdxField) {
    let ySeriesNames;
    if (!yAxisIdxField) ySeriesNames = [];
    else if (!Array.isArray(yAxisIdxField)) // when using pie chart we drop isMultiple
    // so the field itself only takes on a single value
    ySeriesNames = [
        yAxisIdxField
    ];
    else ySeriesNames = yAxisIdxField;
    return ySeriesNames;
}
const $0448137591457623$export$b6fe27aebea9b8db = (inputData, intl)=>{
    const firstRow = inputData[0];
    if (!firstRow) return [];
    return firstRow.map((col, idx)=>{
        if (col.length) // if there was some text in the column heading, use
        // that as the column name
        return {
            label: col,
            value: String(idx)
        };
        return {
            label: intl.formatMessage((0, $9P5aG.i18n).defaultColumnName, {
                0: idx + 1
            }),
            value: String(idx)
        };
    });
};
const $0448137591457623$export$61b2588d814439ab = (table, userSelectedColumn, aggregateData)=>{
    if (!aggregateData) /* slice header row */ return table.slice(1).map((row)=>row[userSelectedColumn]);
    else /* slice header row and return only unique values when the data is aggregated */ return table.slice(1).map((row)=>row[userSelectedColumn]).filter((value, index, array)=>array.indexOf(value) === index);
};
const $0448137591457623$export$ed60ee4b8716ad1a = (inputData, parseNumber)=>{
    /* slice out heading row */ const tableData = inputData.slice(1);
    // convert ['2012', '8', 'text', '121'] into
    // { 0: 2012, 1: 8, 2: 'text', 3: 121 }
    const namedTableData = tableData.map((dataRow, rowIdx)=>dataRow.reduce((namedData, colData, colIdx)=>{
            if (colData.trim() === '') namedData[colIdx] = undefined;
            else {
                /* has content; try to parse as number, leaving as text otherwise */ const val = parseNumber(colData);
                if (colData.length && val !== null) namedData[colIdx] = val;
                else /* couldn't parse as number */ namedData[colIdx] = colData;
            }
            return namedData;
        }, {}));
    return namedTableData;
};
const $0448137591457623$export$2b32e0822fbb56 = (tableData, xAxisSeriesKey, aggregateData)=>{
    let finalTableData = [
        ...tableData
    ];
    if (!aggregateData) {
        const uniqueSet = new Set();
        finalTableData.forEach((row)=>{
            let uniqueValue = row[xAxisSeriesKey];
            if (uniqueValue) {
                let count = 2;
                while(uniqueSet.has(uniqueValue)){
                    uniqueValue = `${row[xAxisSeriesKey]} (${count})`;
                    count = count + 1;
                }
                uniqueSet.add(uniqueValue);
            }
            row[xAxisSeriesKey] = uniqueValue;
        });
    } else {
        const uniqueSet = new Set();
        for(let idx = 0; idx < finalTableData.length; idx++){
            const row = finalTableData[idx];
            const uniqueValue = row[xAxisSeriesKey];
            if (uniqueSet.has(uniqueValue)) {
                const singleRow = finalTableData.find((uniqueRow)=>uniqueRow[xAxisSeriesKey] === uniqueValue);
                for(const seriesName in singleRow)if (seriesName !== xAxisSeriesKey) singleRow[seriesName] = Number(singleRow[seriesName]) + Number(row[seriesName]);
                finalTableData.splice(idx, 1);
                idx -= 1;
            } else uniqueSet.add(uniqueValue);
        }
    }
    return finalTableData;
};
const $0448137591457623$export$7e951c8f516ac2da = (hexCodeWithAlpha)=>{
    return hexCodeWithAlpha.substring(0, 7);
};
const $0448137591457623$export$10abeb71100c5a72 = (variableExpression)=>{
    const matcher = variableExpression.match(/var\(([^,\)]+)(,.*)?\)/);
    if (matcher) {
        const variable = matcher[1].trim();
        const fallback = matcher[2] ? matcher[2].replace(',', '').trim() : '';
        if (typeof document === 'undefined') return fallback;
        const value = window.getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
        return value || fallback;
    }
    return '';
};
module.exports["normaliseYSeriesNames"] = $0448137591457623$export$8bbd55d690f3e574;
module.exports["createColumnNames"] = $0448137591457623$export$b6fe27aebea9b8db;
module.exports["getColData"] = $0448137591457623$export$61b2588d814439ab;
module.exports["extractTableData"] = $0448137591457623$export$ed60ee4b8716ad1a;
module.exports["formatTableData"] = $0448137591457623$export$2b32e0822fbb56;
module.exports["getCSSVariableValue"] = $0448137591457623$export$10abeb71100c5a72;

});

parcelRegister("9LoQD", function(module, exports) {

var $dQl1W = parcelRequire("dQl1W");


var $itfXp = parcelRequire("itfXp");

const $da5ab8b42ba90d6f$export$3319ac758543a741 = ({ adf: adf, intl: intl, parseNumber: parseNumber, sourceId: sourceId })=>{
    return {
        type: 'extension',
        attrs: {
            extensionType: 'com.atlassian.chart',
            extensionKey: 'chart:default',
            parameters: (0, $itfXp.defaultParameters)(adf, intl, parseNumber),
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            localId: (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))()
        },
        marks: [
            {
                type: 'dataConsumer',
                attrs: {
                    sources: [
                        sourceId
                    ]
                }
            }
        ]
    };
};
module.exports["buildChartADF"] = $da5ab8b42ba90d6f$export$3319ac758543a741;

});

parcelRegister("gr9zL", function(module, exports) {

let $bf7698881e72c991$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bf7698881e72c991$var$load("eNZNF"),
    $bf7698881e72c991$var$load("wIOhQ"),
    $bf7698881e72c991$var$load("hRqzw"),
    $bf7698881e72c991$var$load("d0iuj")
]).then(()=>parcelRequire('dw9M4'));

});

parcelRegister("gEHBP", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aqrhZ = parcelRequire("aqrhZ");


var $dx8CK = parcelRequire("dx8CK");


var $9P5aG = parcelRequire("9P5aG");


var $9Lqvw = parcelRequire("9Lqvw");





// eslint-disable-next-line import/dynamic-import-chunkname
const $16fa5d0296019787$var$editSourceIcon = ()=>Promise.resolve((parcelRequire("dk0le")));
const $16fa5d0296019787$export$60b44ef2f55702a1 = ({ intl: intl, editorActions: editorActions, externalToolbarItems: externalToolbarItems = [] })=>({
        context: {
            type: 'extension',
            nodeType: 'extension',
            extensionKey: 'chart:default',
            extensionType: 'com.atlassian.chart'
        },
        toolbarItems: (adf, _api)=>{
            if (!editorActions) return [];
            const { sources: sources = [] } = (adf.marks || []).find((mark)=>mark.type === 'dataConsumer')?.attrs || {};
            const hasSource = sources.some((source)=>editorActions.getNodeByFragmentLocalId(source) || editorActions.getNodeByLocalId(source));
            return [
                {
                    key: 'edit-chart',
                    display: 'label',
                    label: intl.formatMessage((0, $9P5aG.i18n).chartOptionsLabel),
                    tooltip: intl.formatMessage((0, $9P5aG.i18n).chartOptionsTooltip),
                    disabled: !hasSource,
                    action: async (_adf, api)=>{
                        return api.editInContextPanel((parameters)=>parameters, (parameters)=>Promise.resolve(parameters));
                    }
                },
                {
                    key: 'edit-source-table',
                    display: 'icon-and-label',
                    label: intl.formatMessage((0, $9P5aG.i18n).editSourceLabel),
                    disabled: !hasSource,
                    tooltip: intl.formatMessage((0, $9P5aG.i18n).editSourceTooltip),
                    icon: $16fa5d0296019787$var$editSourceIcon,
                    action: async (_adf, api)=>{
                        if (!hasSource) throw new Error('Table source is not found');
                        // sourceId can be either localId or fragment localId
                        let sourceId = sources[0];
                        // search the nodes if there's a fragment mark with matching source id then use its localId to scroll
                        const nodeByFragmentLocalId = editorActions.getNodeByFragmentLocalId(sourceId);
                        if (nodeByFragmentLocalId) sourceId = nodeByFragmentLocalId.attrs.localId;
                        api.doc.scrollTo(sourceId);
                    }
                },
                ...externalToolbarItems
            ];
        }
    });





parcelRequire("42omo");


var $1zLiv = parcelRequire("1zLiv");


var $4DzVW = parcelRequire("4DzVW");


var $cyLm6 = parcelRequire("cyLm6");





var $8PJdr = parcelRequire("8PJdr");


var $itfXp = parcelRequire("itfXp");





var $grNUj = parcelRequire("grNUj");


var $2NCZX = parcelRequire("2NCZX");




const $6be833dc9887d387$var$getTableViaEditor = (editorActions)=>{
    const sourceAdf = (0, $dx8CK.dataSourceResolver)(editorActions);
    if (!sourceAdf?.[(0, $dx8CK.ADFReferenceTypes).TABLE]) return [];
    return (0, $9Lqvw.parseTable)(sourceAdf[(0, $dx8CK.ADFReferenceTypes).TABLE]);
};
const $6be833dc9887d387$var$getColorSeries = (parameters, intl, actions)=>{
    const table = $6be833dc9887d387$var$getTableViaEditor(actions);
    const seriesOptions = (0, $2NCZX.createColumnNames)(table, intl);
    const ySeriesNames = (0, $2NCZX.normaliseYSeriesNames)(parameters.chartGroup?.dataTab?.yAxisIdxField);
    const ySeriesOptions = seriesOptions.filter((opt)=>ySeriesNames.indexOf(opt.value) > -1);
    const isAggregateData = !!parameters.chartGroup?.dataTab?.aggregateData;
    const isPieChart = parameters.chartType === (0, $grNUj.ChartTypes).PIE;
    const colData = (0, $2NCZX.getColData)(table, Number(parameters.chartGroup?.dataTab?.xAxisIdxField || '0'), isAggregateData);
    const colDataOptions = colData.map((colDataString, idx)=>({
            value: String(idx),
            label: colDataString
        }));
    const generateColorOption = (isPieChart)=>({ label: label, value: value }, idx)=>{
            // If there's more rows than available colors,
            // cycle back through the colors
            const safeIdx = idx % (0, $8PJdr.colorSequenceForExtendedChartsColorPicker).length;
            const { getValue: getValue } = (0, $8PJdr.colorSequenceForExtendedChartsColorPicker)[safeIdx];
            return {
                type: 'color',
                label: label,
                name: `color${isPieChart ? 'Pie' : 'Linear'}${value}`,
                defaultValue: getValue()
            };
        };
    return (isPieChart ? colDataOptions : ySeriesOptions).map(generateColorOption(isPieChart));
};
const $6be833dc9887d387$var$dataSourceFields = (parameters, intl, actions)=>{
    const table = $6be833dc9887d387$var$getTableViaEditor(actions);
    const seriesOptions = (0, $2NCZX.createColumnNames)(table, intl);
    // config panel doesn't like values being removed from under it
    // repro: use pie, cycle category until you get one that overlaps with data series
    // it's missing in the data but the UI will show the old data
    // const dataSeriesWithoutXAxis = dataSeriesFromTable.filter(opt => opt.value !== parameters.chartGroup?.dataTab.xAxisIdxField)
    const isPieChart = parameters.chartType === (0, $grNUj.ChartTypes).PIE;
    return [
        {
            name: 'xAxisIdxField',
            type: 'enum',
            style: 'select',
            isMultiple: false,
            defaultValue: '0',
            // number as string
            items: seriesOptions,
            label: isPieChart ? intl.formatMessage((0, $9P5aG.i18n).categoryName) : intl.formatMessage((0, $9P5aG.i18n).xAxisSeriesName)
        },
        {
            name: 'yAxisIdxField',
            type: 'enum',
            style: 'select',
            isMultiple: !isPieChart,
            label: intl.formatMessage((0, $9P5aG.i18n).seriesNames),
            items: seriesOptions
        }
    ];
};
const $6be833dc9887d387$export$3b644ff951ba4e09 = (intl, actions)=>(parameters)=>{
        const dataFields = $6be833dc9887d387$var$dataSourceFields(parameters, intl, actions);
        // absolutely broken
        // should also not depend on recalculating the same shit
        const colorFields = $6be833dc9887d387$var$getColorSeries(parameters, intl, actions);
        return [
            {
                name: 'chartType',
                type: 'enum',
                style: 'select',
                isMultiple: false,
                defaultValue: (0, $itfXp.DEFAULT_CHART_TYPE),
                items: [
                    {
                        label: intl.formatMessage((0, $9P5aG.i18n).chartTypeBar),
                        value: (0, $grNUj.ChartTypes).BAR,
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1zLiv))), {
                            color: "currentColor",
                            label: ''
                        })
                    },
                    {
                        label: intl.formatMessage((0, $9P5aG.i18n).chartTypeLine),
                        value: (0, $grNUj.ChartTypes).LINE,
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cyLm6))), {
                            color: "currentColor",
                            label: ''
                        })
                    },
                    {
                        label: intl.formatMessage((0, $9P5aG.i18n).chartTypePie),
                        value: (0, $grNUj.ChartTypes).PIE,
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4DzVW))), {
                            color: "currentColor",
                            label: ''
                        })
                    }
                ],
                label: intl.formatMessage((0, $9P5aG.i18n).chartTypeField)
            },
            {
                type: 'tab-group',
                label: '',
                name: 'chartGroup',
                defaultTab: intl.formatMessage((0, $9P5aG.i18n).dataTabTitle),
                hasGroupedValues: true,
                fields: [
                    {
                        type: 'tab',
                        name: 'dataTab',
                        label: intl.formatMessage((0, $9P5aG.i18n).dataTabTitle),
                        hasGroupedValues: true,
                        fields: [
                            ...dataFields,
                            {
                                name: 'aggregateData',
                                type: 'boolean',
                                defaultValue: parameters.chartGroup?.dataTab?.aggregateData,
                                label: intl.formatMessage((0, $9P5aG.i18n).aggregateData),
                                style: 'toggle',
                                description: intl.formatMessage((0, $9P5aG.i18n).aggregateDataDescription)
                            }
                        ]
                    },
                    {
                        type: 'tab',
                        name: 'customizeTab',
                        label: intl.formatMessage((0, $9P5aG.i18n).customizeTabTitle),
                        hasGroupedValues: true,
                        fields: [
                            {
                                name: 'styleField',
                                type: 'expand',
                                label: intl.formatMessage((0, $9P5aG.i18n).styleExpand),
                                hasGroupedValues: true,
                                fields: [
                                    {
                                        name: 'height',
                                        type: 'enum',
                                        label: intl.formatMessage((0, $9P5aG.i18n).heightField),
                                        style: 'select',
                                        defaultValue: '350',
                                        items: [
                                            {
                                                value: '150',
                                                label: intl.formatMessage((0, $9P5aG.i18n).small)
                                            },
                                            {
                                                value: '350',
                                                label: intl.formatMessage((0, $9P5aG.i18n).medium)
                                            },
                                            {
                                                value: '550',
                                                label: intl.formatMessage((0, $9P5aG.i18n).large)
                                            }
                                        ]
                                    },
                                    ...colorFields,
                                    {
                                        name: 'showPoints',
                                        type: 'boolean',
                                        label: intl.formatMessage((0, $9P5aG.i18n).showPoints),
                                        style: 'toggle',
                                        isHidden: parameters.chartType !== (0, $grNUj.ChartTypes).LINE
                                    },
                                    {
                                        name: 'smooth',
                                        type: 'boolean',
                                        label: intl.formatMessage((0, $9P5aG.i18n).smoothLines),
                                        style: 'toggle',
                                        isHidden: parameters.chartType !== (0, $grNUj.ChartTypes).LINE
                                    },
                                    {
                                        name: 'orientation',
                                        type: 'enum',
                                        label: intl.formatMessage((0, $9P5aG.i18n).orientationLabel),
                                        style: 'select',
                                        defaultValue: 'vertical',
                                        isHidden: parameters.chartType === (0, $grNUj.ChartTypes).PIE,
                                        items: [
                                            {
                                                label: intl.formatMessage((0, $9P5aG.i18n).verticalOrientation),
                                                value: 'vertical'
                                            },
                                            {
                                                label: intl.formatMessage((0, $9P5aG.i18n).horizontalOrientation),
                                                value: 'horizontal'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                name: 'titlesField',
                                type: 'expand',
                                label: intl.formatMessage((0, $9P5aG.i18n).titleExpand),
                                hasGroupedValues: true,
                                fields: [
                                    {
                                        name: 'chartTitle',
                                        type: 'string',
                                        placeholder: parameters.chartGroup?.customizeTab?.titlesField?.chartTitle,
                                        label: intl.formatMessage((0, $9P5aG.i18n).chartTitle)
                                    },
                                    {
                                        name: 'yLabel',
                                        type: 'string',
                                        placeholder: parameters.chartGroup?.customizeTab?.titlesField?.yLabel,
                                        label: intl.formatMessage((0, $9P5aG.i18n).yLabel),
                                        isHidden: parameters.chartType === (0, $grNUj.ChartTypes).PIE
                                    },
                                    {
                                        name: 'xLabel',
                                        type: 'string',
                                        placeholder: parameters.chartGroup?.customizeTab?.titlesField?.yLabel,
                                        label: intl.formatMessage((0, $9P5aG.i18n).xLabel),
                                        isHidden: parameters.chartType === (0, $grNUj.ChartTypes).PIE
                                    }
                                ]
                            },
                            {
                                name: 'legendField',
                                type: 'expand',
                                label: intl.formatMessage((0, $9P5aG.i18n).legendExpand),
                                hasGroupedValues: true,
                                fields: [
                                    {
                                        name: 'showLegend',
                                        type: 'boolean',
                                        label: intl.formatMessage((0, $9P5aG.i18n).showLegend),
                                        style: 'toggle'
                                    },
                                    {
                                        name: 'legendPosition',
                                        type: 'enum',
                                        style: 'select',
                                        isMultiple: false,
                                        defaultValue: (0, $itfXp.DEFAULT_LEGEND_POSITION),
                                        items: [
                                            {
                                                label: intl.formatMessage((0, $9P5aG.i18n).legendAuto),
                                                value: (0, $grNUj.UserLegendPosition).AUTO
                                            },
                                            {
                                                label: intl.formatMessage((0, $9P5aG.i18n).legendTop),
                                                value: (0, $grNUj.UserLegendPosition).TOP
                                            },
                                            {
                                                label: intl.formatMessage((0, $9P5aG.i18n).legendLeft),
                                                value: (0, $grNUj.UserLegendPosition).LEFT
                                            },
                                            {
                                                label: intl.formatMessage((0, $9P5aG.i18n).legendRight),
                                                value: (0, $grNUj.UserLegendPosition).RIGHT
                                            },
                                            {
                                                label: intl.formatMessage((0, $9P5aG.i18n).legendBottom),
                                                value: (0, $grNUj.UserLegendPosition).BOTTOM
                                            }
                                        ],
                                        label: intl.formatMessage((0, $9P5aG.i18n).legendPosition)
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];
    };





parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");







const $24cee667e56eecc2$export$6250fa3bb5017828 = (sourceNode, createAnalyticsEvent)=>{
    if (!createAnalyticsEvent) return;
    const sourceAttributes = {
        sourceNodeType: sourceNode.type
    };
    // Source is Connect macro
    if (sourceNode.type === 'extension' && sourceNode.attrs?.extensionType === 'com.atlassian.confluence.macro.core') Object.assign(sourceAttributes, {
        sourceExtensionType: sourceNode.attrs?.extensionType,
        sourceExtensionKey: sourceNode.attrs?.extensionKey,
        sourceExtensionTitle: sourceNode.attrs?.parameters?.macroMetadata?.title,
        sourceExtensionParameters: sourceNode.attrs?.parameters
    });
    const analyticsData = {
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createReference',
            source: 'editorFloatingToolbar',
            attributes: {
                ...sourceAttributes,
                targetNodeType: 'extension',
                targetExtensionType: 'com.atlassian.chart',
                targetExtensionKey: 'chart:default'
            }
        }
    };
    createAnalyticsEvent(analyticsData).fire();
};



var $9LoQD = parcelRequire("9LoQD");

function $2714470b73a07ef0$var$insertChartIcon() {
    return ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1zLiv))), {
            label: "",
            spacing: "spacious"
        });
}
const $2714470b73a07ef0$export$37f0192167b4c738 = ({ intl: intl, parseNumber: parseNumber, createAnalyticsEvent: createAnalyticsEvent, onInsertButton: onInsertButton })=>{
    return {
        context: {
            type: 'node',
            nodeType: 'table'
        },
        toolbarItems: (adf, _api)=>{
            // CEMS-2157: waiting on CEMS-2226 and CEMS-2227
            // const disabled = !tableHasNumbers(adf, parseNumber);
            const disabled = false;
            return [
                {
                    key: 'insert-chart',
                    display: 'icon',
                    disabled: disabled,
                    icon: $2714470b73a07ef0$var$insertChartIcon,
                    label: intl.formatMessage((0, $9P5aG.i18n).insertChartTooltip),
                    tooltip: intl.formatMessage((0, $9P5aG.i18n).insertChartTooltip),
                    action: async (adf, api)=>{
                        const localId = adf.attrs?.localId || '';
                        let sourceId = localId;
                        const existingFragmentMark = adf.marks?.find((m)=>m.type === 'fragment');
                        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                        sourceId = existingFragmentMark?.attrs?.localId || (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
                        if (!existingFragmentMark) api.doc.update(localId, ({ attrs: attrs, marks: marks })=>({
                                attrs: attrs,
                                marks: (marks ?? []).concat({
                                    type: 'fragment',
                                    attrs: {
                                        localId: sourceId
                                    }
                                })
                            }));
                        const chartADF = (0, $9LoQD.buildChartADF)({
                            adf: adf,
                            intl: intl,
                            parseNumber: parseNumber,
                            sourceId: sourceId
                        });
                        api.doc.insertAfter(localId, chartADF, {
                            allowSelectionToNewNode: true
                        });
                        (0, $24cee667e56eecc2$export$6250fa3bb5017828)(adf, createAnalyticsEvent);
                        if (onInsertButton) onInsertButton(adf);
                    }
                }
            ];
        }
    };
};



const $9403d90fe8311a5a$var$LazyChart = (0, $aqrhZ.lazyForPaint)(()=>(parcelRequire("gr9zL")).then((m)=>m.Chart));
const $9403d90fe8311a5a$var$Skeleton = ({ height: height })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            height: height
        }
    });

const $9403d90fe8311a5a$export$1e0e908bcaf7534e = ({ intl: intl, editorActions: editorActions, parseNumber: parseNumber, extensionHandlerWithReference: extensionHandlerWithReference, createAnalyticsEvent: createAnalyticsEvent, onInsertButton: onInsertButton, featureFlags: featureFlags, externalToolbarItems: externalToolbarItems })=>({
        title: intl ? intl.formatMessage((0, $9P5aG.i18n).extensionTitle) : (0, $9P5aG.i18n).extensionTitle.defaultMessage,
        type: 'com.atlassian.chart',
        key: 'chart',
        icons: {
            '48': ()=>Promise.resolve((parcelRequire("1zLiv")))
        },
        modules: {
            contextualToolbars: [
                (0, $2714470b73a07ef0$export$37f0192167b4c738)({
                    intl: intl,
                    parseNumber: parseNumber || (0, $9Lqvw.defaultParseNumber),
                    createAnalyticsEvent: createAnalyticsEvent,
                    onInsertButton: onInsertButton,
                    featureFlags: featureFlags
                }),
                (0, $16fa5d0296019787$export$60b44ef2f55702a1)({
                    intl: intl,
                    editorActions: editorActions,
                    externalToolbarItems: externalToolbarItems
                })
            ],
            nodes: {
                default: {
                    type: 'extension',
                    render: ()=>{
                        const chartComponent = (node, references)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aqrhZ.LazySuspense), {
                                fallback: /*#__PURE__*/ (0, $l998X.jsx)($9403d90fe8311a5a$var$Skeleton, {
                                    height: node.parameters?.chartGroup?.customizeTab?.styleField?.height || 350
                                }),
                                children: /*#__PURE__*/ (0, $l998X.jsx)($9403d90fe8311a5a$var$LazyChart, {
                                    data: references[0]?.[(0, $dx8CK.ADFReferenceTypes).TABLE],
                                    parseNumber: parseNumber,
                                    intl: intl,
                                    localId: node.localId,
                                    ...node.parameters
                                })
                            });
                        return Promise.resolve(({ node: node, references: references, refNode: refNode })=>{
                            if (refNode) references = [
                                refNode
                            ];
                            if (extensionHandlerWithReference) return extensionHandlerWithReference(node, ({ references: referencesFromHandler })=>chartComponent(node, referencesFromHandler));
                            return chartComponent(node, references);
                        });
                    },
                    getFieldsDefinition: async ()=>{
                        const fields = (0, $6be833dc9887d387$export$3b644ff951ba4e09)(intl, editorActions);
                        return (parameters)=>fields(parameters);
                    }
                }
            }
        }
    });
module.exports["buildManifest"] = $9403d90fe8311a5a$export$1e0e908bcaf7534e;

});


//# sourceMappingURL=charts.8d82b79c.js.map
